// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header_logo-module__logo--1aNuW{display:flex;margin-right:145px;align-items:center;justify-content:flex-start}@media screen and (max-width: 79.9375em){.header_logo-module__logo--1aNuW{margin-right:36px}}@media screen and (max-width: 62.5625em){.header_logo-module__logo--1aNuW{margin-right:0px}}\n", ""]);
// Exports
exports.locals = {
	"logo": "header_logo-module__logo--1aNuW"
};
module.exports = exports;
